import { baseDroneApi } from '@src/core/features';
import { IGetNtripRequest, IGetNtripResponse, ISendCommandRequest, ITakeOffRequest, IUpdateNtripRequest } from './types';

export const droneFeatureApi = baseDroneApi.injectEndpoints({
  endpoints: (builder) => ({

    takeOff: builder.mutation<void, ITakeOffRequest>({
      invalidatesTags: ['GetDrones'],
      query: ({droneId, altitude, unitSystem}) => ({
        // New body endpoint (the path-altitude route is deprecated); altitude is SI (m),
        // unitSystem=METRIC is the guard the backend enforces (UnitSystemGuard).
        url: `/api/v2/orders/direct-command/${droneId}/TAKE_OFF`,
        method: 'POST',
        data: { altitude, unitSystem }
      })
    }),

    sendCommand: builder.mutation<void, ISendCommandRequest>({
      query: ({ droneId, command }) => ({
        url: `/api/v2/orders/direct-command/${droneId}/${command}`,
        method: 'POST',
      })
    }),

    updateNtrip: builder.mutation<void, IUpdateNtripRequest>({
      invalidatesTags: ['Drone'],
      query: ({ droneId, ...data }) => ({
        url: `/api/v1/drone/${droneId}/ntrip`,
        method: 'PUT',
        data,
      })
    }),
    getNtrip: builder.query<IGetNtripResponse, IGetNtripRequest>({
      query: ({ droneId }) => ({
        url: `/api/v1/drone/${droneId}/ntrip`,
        method: 'GET',
      }),
      providesTags: ['Drone'],
    }),
  })
});

export const { 
  useSendCommandMutation,
  useTakeOffMutation,
  useUpdateNtripMutation,
  useGetNtripQuery,
} = droneFeatureApi;
